import './menu-list.scss';
import 'isomorphic-fetch';
import React from 'react';
import Permissable from '../../permission/Permissable';
import { formatMessage } from '../../intl/helper';
import languagePart from '../../intl/messages/container/part5/index';
import languageGlobal from '../../intl/messages/global';
import languageMine from '../../intl/messages/mine';
const classnames = require('classnames');
const commonHelper = require('../../helper/common-helper');
const tableId = commonHelper.getUrlParam('tableId');

import HttpsProtocolImage from '../../component/common/https-protocol-image';

class MenuList extends React.Component {
  constructor(props) {
    super(props);
    this.openShopList = this.openShopList.bind(this);
  }

  setEmptyBlocks() {
    let emptyBlockCount = 0;
    const blockArr = [];

    if ((this.props.menuList.length - 3) % 3 === 2) {
      emptyBlockCount = 1;
    } else if ((this.props.menuList.length - 3) % 3 === 1) {
      emptyBlockCount = 2;
    } else {
      emptyBlockCount = 0;
    }

    for (let i = 0; i < emptyBlockCount; i++) {
      blockArr.push(
        <div className="item" key={i}>
          <a></a>
        </div>,
      );
    }

    return blockArr;
  }
  // 处理menu链接函数
  openShopList(e, item, memberVO) {
    e.preventDefault();
    const { link, uniqueId } = item;
    if (uniqueId === 'PD' && this.props.brandMenu !== 0) {
      this.props.getCheckQueue();
      return;
    }

    if (link) {
      let ownerId = '';
      if (uniqueId === 'TS' && memberVO && memberVO.customerId) {
        ownerId = `&ownerId=${memberVO.customerId}`;
      }
      location.href = `${link}${ownerId}`;
    }
  }

  getTextByLanguage(type, name) {
    let res = name;
    switch (type) {
      case 'WM':
        if (name === '外卖') {
          // 此处必须用"外卖"来区分逻辑， 不需要国际化处理
          res = formatMessage(languagePart.OrderListApplicationWM);
        } else {
          res = name;
        }
        break;
      case 'TS':
        res = formatMessage(languagePart.OrderListApplicationTS);
        break;
      case 'YD':
        res = formatMessage(languagePart.OrderListApplicationYD);
        break;
      case 'PD':
        res = formatMessage(languagePart.OrderListApplicationPD);
        break;
      case 'HY':
        res = formatMessage(languageGlobal.vip);
        break;
      case 'WD':
        res = formatMessage(languageMine.minemeCenter);
        break;
      case 'XLS': // 针对零售展示
        res = formatMessage(languageGlobal.microMart);
        break;
      default:
        break;
    }
    return res;
  }

  render() {
    const emptyBlocks = this.setEmptyBlocks();
    const { shopHomeScan, memberVO } = this.props;
    let menuList = this.props.menuList;
    if (tableId) {
      // 表示扫码进入 不展示堂食入口
      menuList = this.props.menuList.filter(item => item.uniqueId !== 'TS');
    }

    return (
      <div className="menu-list">
        {menuList.map((item, index) => {
          const { uniqueId, name, imageLink } = item;
          const languageText = this.getTextByLanguage(uniqueId, name);
          return (
            <Permissable id={`entry.${uniqueId}`} key={uniqueId}>
              <div className={classnames('item', { 'item--modify': !!shopHomeScan })} key={index}>
                <a href=" javascript:void(0)" onTouchTap={e => this.openShopList(e, item, memberVO)}>
                  <i
                    className={classnames('icon', {
                      [`icon-${item.uniqueId}--modify`]: !!shopHomeScan,
                      [`icon-${uniqueId}`]: !imageLink || uniqueId === 'XLS',  // 微商城展示原有样式，即使imageLink不为空
                      ['icon-default']: !imageLink || uniqueId === 'XLS',
                    })}
                    style={{ backgroundImage: !!imageLink && uniqueId !== 'XLS' && `url(${HttpsProtocolImage.getFinalImageUrl(imageLink)})` }}
                  ></i>
                  <span>{languageText}</span>
                </a>
              </div>
            </Permissable>
          );
        })}
        {emptyBlocks}
      </div>
    );
  }
}

MenuList.propTypes = {
  menuList: React.PropTypes.array,
  shopDetail: React.PropTypes.object,
  getCheckQueue: React.PropTypes.func,
  brandMenu: React.PropTypes.number,
  shopHomeScan: React.PropTypes.bool,
  memberVO: React.PropTypes.object,
};

export default MenuList;



// WEBPACK FOOTER //
// ./src/component/shop-home/menu-list.jsx